import React from 'react';
import { Avatar, Tag } from 'antd';

import {
  formatWinnerProgress,
  getWinnerInfos,
  isSelectionComplete,
} from '../winners';

/**
 * Avatars + usernames for N winners (campaign.winnerCount), with optional progress tag.
 */
export default function WinnerInfosDisplay({ campaign, showProgress = true, size = 28 }) {
  const infos = getWinnerInfos(campaign);
  const complete = isSelectionComplete(campaign);

  if (!infos.length) {
    return (
      <span>
        No winners selected
        {showProgress && campaign ? (
          <Tag style={{ marginLeft: 8 }}>{formatWinnerProgress(campaign)}</Tag>
        ) : null}
      </span>
    );
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
      {infos.map((winner) => (
        <span
          key={(winner && winner._id) || winner.username}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <Avatar src={winner && winner.image} size={size}>
            {winner && winner.username ? winner.username.charAt(0).toUpperCase() : 'W'}
          </Avatar>
          <span>{(winner && (winner.username || winner._id)) || 'Unknown'}</span>
        </span>
      ))}
      {showProgress && campaign ? (
        <Tag color={complete ? 'blue' : 'orange'}>{formatWinnerProgress(campaign)}</Tag>
      ) : null}
    </div>
  );
}
